/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext } from "react";
import { Select } from "antd";
import MapPropsContext from "../MapPropsContext";
import { Title } from "./Common";
import { OPTION_YEAR } from "../../../utils";
import { TI_SELECT_YEAR_COMBO } from "../../../Constants";

const { Option } = Select;

const WidgetSelectYear = ({ isNoneLatestData = false }) => {
  const { geojsonExtraParams, setGeojsonExtraParams } = useContext(MapPropsContext);

  const onYearChange = useCallback((date) => {
    const year = parseInt(date);
    const month = 12;
    window.searchYear = year;
    window.new_param =
      "sidoCode=" +
      window.sidoCode +
      "&gubun_code=" +
      window._gubun_code +
      "&searchYear=" +
      window.searchYear +
      "&chkRadSvcString=" +
      window.chkRadSvcString;
    setGeojsonExtraParams((params) => ({ ...params, year, month }));
  }, []);

  const { year } = geojsonExtraParams;

  return (
    <div>
      <Title>기준년도</Title>
      <Select defaultValue={year} onChange={onYearChange} style={{ width: "100%" }} tabIndex={TI_SELECT_YEAR_COMBO}>
        {isNoneLatestData &&
          OPTION_YEAR()
            .filter(({ value }) => value < 2019)
            .map(({ value }) => (
              <Option value={value} key={value}>
                {value}
              </Option>
            ))}
        {!isNoneLatestData &&
          OPTION_YEAR().map(({ value }) => (
            <Option value={value} key={value}>
              {value}
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default WidgetSelectYear;
